<!-- BOTONES: Archivar / Datos de facturación / Intranet -->

<div *ngIf="(cliente.id)"
     class="col-md-4 mt-4 d-flex justify-content-end align-items-start">
    <div class="form-group float-right mb-0">

        <button *ngIf="(!cliente.archivado)"
                [disabled]="loading"
                (click)="archivarClick()"
                type="button"
                title="Desactivar el cliente, no mostrarlo en desplegables"
                class="btn waves-effect waves-light btn-outline-warning mr-2">
            <i *ngIf="loading"
               class="fa fa-spinner fa-spin"></i>
            Archivar
        </button>

        <button *ngIf="(cliente.archivado)"
                [disabled]="loading"
                (click)="archivarClick()"
                type="button"
                title="El cliente se mostrará en desplegables"
                class="btn waves-effect waves-light btn-outline-success mr-2">
            <i *ngIf="loading"
               class="fa fa-spinner fa-spin"></i>
            Reactivar
        </button>

        <div class="btn-group">

            <button [disabled]="loading"
                    [routerLink]="['/panel/cliente_edit', cliente.id]"
                    type="button"
                    title="Modificar datos del cliente"
                    class="btn waves-effect waves-light btn-outline-info"
                    [class.active]="activeTab === 'datos'">
                Datos
            </button>

            <button [disabled]="loading"
                    [routerLink]="['/panel/cliente_edit_intranet', cliente.id]"
                    type="button"
                    title="Modificar datos de acceso a la intranet"
                    class="btn waves-effect waves-light btn-outline-info"
                    [class.active]="activeTab === 'intranet'">
                Intranet
            </button>

            <button [disabled]="loading"
                    [routerLink]="['/panel/cliente_edit_fac', cliente.id]"
                    type="button"
                    title="Modificar datos de facturación"
                    class="btn waves-effect waves-light btn-outline-info"
                    [class.active]="activeTab === 'facturacion'">
                Facturación
            </button>

        </div>

        <button *ngIf="(cliente.acceso_intranet === 'S')"
                [disabled]="loading"
                (click)="modalAvisoCli(cliente)"
                type="button"
                title="Enviar una NOTIFICACIÓN que verá en la intranet del cliente"
                class="rounded-circle btn btn-outline-info ml-2">
            <i class="fa-solid fa-envelope"></i>
        </button>
    </div>
</div>



<!-- Es un alta de cliente -->
<div *ngIf="(!cliente.id && !loading)"
     class=" d-flex justify-content-end">
    <div class="col-auto mt-4">
        <h3 class="text-info fw-bold text-nowrap">Nuevo Cliente</h3>
    </div>
</div>